/* global grecaptcha */

const MAX_SECONDS_TO_WAIT = 30

export function onRecaptchaAvailable(callback, expectedProperty = null) {
  if (typeof callback !== 'function') {
    return
  }

  if (typeof grecaptcha !== 'undefined' && (!expectedProperty || expectedProperty in grecaptcha)) {
    callback()
    return
  }

  const startedAt = Date.now()
  let timer = null

  timer = setInterval(() => {
    if (typeof grecaptcha === 'undefined' || (expectedProperty && !(expectedProperty in grecaptcha))) {
      if (Date.now() - startedAt >= MAX_SECONDS_TO_WAIT) {
        clearInterval(timer)
      }
      return
    }
    clearInterval(timer)
    callback()
  }, 250)
}

export function onRecaptchaV2Available(callback) {
  onRecaptchaAvailable(callback, 'render')
}

export function onRecaptchaV3Available(callback) {
  onRecaptchaAvailable(callback, 'execute')
}
